<template>
	<!-- <v-container fluid>
		<v-row class="fill-height" align="center" justify="center"  >
			<v-col mx-auto>
				<v-form ref="f">
					<a-file-picker
						v-model="file"
						:label="label"
						:multiple="multiple"
						:required="required"
						:formats="formats"
						:maxSize="maxSize"
					/>
				</v-form>
				<v-btn @click="upload">Upload</v-btn>
				<v-btn @click="reset">Reset</v-btn>
			</v-col>
		</v-row>
	</v-container> -->
	<v-container>
		<v-row>
			<v-col class="ml-auto">
				123
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {api} from '../lib/api'
// import aFilePicker from './base/AFilePicker.vue'

export default {
	components: {
		// aFilePicker
	},
	data: () => ({
		// activeTab: true,
		// counter: 0,
		// timer: 0,
		file: [],
		multiple: true,
		required: true,
		formats: 'pdf',
		maxSize: '1'
	}),
	computed: {
		label() {
			let l = []
			if (this.multiple) l.push('multiple')
			if (this.required) l.push('required')
			if (this.formats.length) l.push('formats: ' + this.formats)
			if (+this.maxSize) l.push('maxSize: ' + this.maxSize)
			return l.join(', ')
		}
	},
	mounted() {
		// this.$store.dispatch('dialogNotify', {
		// 	title: 'Hello world',
		// 	message: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
		// })
		// this.startUpdate()
		//
		// window.onfocus = () => {
		// 	// this.activeTab = true
		// 	this.startUpdate()
		// 	document.title = 'LOC Test'
		// }
		// window.onblur = () => {
		// 	// this.activeTab = false
		// 	this.stopUpdate()
		// 	document.title = this.counter
		// }
	},
	destroyed() {
		// this.stopUpdate()
	},
	methods: {
		reset () {
			this.file = []
		},
		upload () {
			// console.log(this.file)

			var formData = new FormData()
			formData.append('form', {})

			for (let i = 0; i < this.file.length; i++) {
				formData.append('file[]', this.file[i])
			}

			this.$store.dispatch('dialogLoadingStart')

			api.post('admin/test', formData)
			.then(response => {
				this.file = []
				this.$refs.f.resetValidation()
				this.$store.dispatch('dialogLoadingStop')
				this.$store.dispatch('dialogDone')
			}, error => {})

		},
		// startUpdate() {
		// 	this.timer = setInterval(() => {
		// 		console.log('iteration')
		// 		// if(!this.activeTab) return
		// 		this.counter = +this.counter + 0.1
		// 		this.counter = this.counter.toFixed(1)
		// 	}, 100)
		// },
		// stopUpdate() {
		// 	clearInterval(this.timer)
		// }
	},
}
</script>
